export enum FileAttachment {
  DISABLED = 0,
  ENABLED = 1,
}

export const FileAttachmentEnum: Record<FileAttachment, string> = {
  [FileAttachment.DISABLED]: 'ファイル添付を許可しない',
  [FileAttachment.ENABLED]: 'ファイル添付を許可する',
};

export const FileAttachmentDisplayEnum: Record<FileAttachment, string> = {
  [FileAttachment.DISABLED]: '禁止',
  [FileAttachment.ENABLED]: '許可',
};